import {
  EXPENSE_FETCHING,
  EXPENSE_FAILED,
  EXPENSE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EXPENSE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case EXPENSE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case EXPENSE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
